"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var Box_1 = require("../Box");
var StyledTable_1 = require("../Table/StyledTable");
var TableContext_1 = require("../Table/TableContext");
var TableCell = function (_a) {
    var children = _a.children, plain = _a.plain, scope = _a.scope, size = _a.size, theme = _a.theme, verticalAlign = _a.verticalAlign, rest = tslib_1.__rest(_a, ["children", "plain", "scope", "size", "theme", "verticalAlign"]);
    return (React.createElement(TableContext_1.TableContext.Consumer, null, function (tableContext) {
        var tableContextTheme;
        if (theme) {
            if (tableContext === 'header') {
                tableContextTheme = theme.table && theme.table.header;
            }
            else if (tableContext === 'footer') {
                tableContextTheme = theme.table && theme.table.footer;
            }
            else {
                tableContextTheme = theme.table && theme.table.body;
            }
        }
        var boxProps = tslib_1.__assign({}, rest);
        Object.keys(boxProps).forEach(function (key) {
            if (tableContextTheme[key] && boxProps[key] === undefined) {
                delete boxProps[key];
            }
        });
        return (React.createElement(StyledTable_1.StyledTableCell, tslib_1.__assign({ as: scope ? 'th' : undefined, scope: scope, size: size, tableContext: tableContext, tableContextTheme: tableContextTheme, verticalAlign: verticalAlign || (tableContextTheme ? tableContextTheme.verticalAlign : undefined) }, (plain ? rest : {})), plain ? (children) : (React.createElement(Box_1.Box, tslib_1.__assign({}, tableContextTheme, boxProps), children))));
    }));
};
var TableCellWrapper = recompose_1.compose(styled_components_1.withTheme)(TableCell);
exports.TableCell = TableCellWrapper;
//# sourceMappingURL=TableCell.js.map